import React from "react";
import BrriLineChart from "./BrriLineChart";
import { generatePath } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { TbListDetails } from "react-icons/tb";

function BrriGraphCard({ title, icon, unit, value, chartData, sensorId }) {
  const navigate = useNavigate();

  const detailsClickHandler = (sensorId) => {
    const path = generatePath("/detailsPage/:sensorId", {
      sensorId: sensorId,
    });
    navigate(path);
  };
  return (
    <div>
      <div className="card theme-background brri-graph-container">
        <div className="row">
          {/* <div className="brri-graph-title theme-text">{title || "title"}</div> */}
          <div className="d-flex justify-content-between">
            <div className="brri-graph-title theme-text">
              {title || "title"}
            </div>
            {sensorId != "122" && (
              <div
                className="details-text theme-text"
                onClick={() => detailsClickHandler(sensorId)}
              >
                <TbListDetails />
                details
              </div>
            )}
          </div>
          <div className="col-md-3 brri-graph-container">
            {/* <div className="brri-graph-title theme-text">
              {title || "title"}
            </div> */}
            <div className="brri-graph-icon">
              {/* <img src={icon || ""}></img> */}
              {icon}
            </div>
            {/* <div className="brri-graph-value theme-text">{value || 0}</div> */}
            <div
              className="brri-graph-value theme-text"
              style={{ textAlign: "left", fontSize: "16px" }}
            >
              {value || 0}
              <span className="brri-unit"> {unit}</span>
            </div>
          </div>
          <div className="col-md-9">
            <BrriLineChart title={title} chartData={chartData} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BrriGraphCard;
